module.exports = __webpack_public_path__ + "img/on-it.c142fc59.png";